import util from '../util'

let controller = 'ParticipanteSpi'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist']), {
  AdicionarListaBancos: function (dto) {
    return util.Axios.Post(controller + '/Lista', dto)
  },
  Combo: function (mostrarInativos) {
    return util.Axios.GetProperty(`${controller}/Combo`, mostrarInativos)
  },
  GetByISPB: function (ispb) {
    return util.Axios.Get(controller + '/GetByISPB', ispb, true)
  }
})
